module.exports = function() {
    var Forms = {};

    /*
        DEPRECATED! Use the more robust serializeObject() library instead: https://github.com/macek/jquery-serialize-object
     */
    //Accepts $('form').serializeArray()
    Forms.SerializeToObject = function (formdataserialized) {
        var formdata = {};
        $.each(formdataserialized, function() {
            if (formdata[this.name] !== undefined) {
                if (!formdata[this.name].push) {
                    formdata[this.name] = [formdata[this.name]];
                }
                formdata[this.name].push(this.value || '');
            } else {
                formdata[this.name] = this.value || '';
            }
        });

        return formdata;
    };

    /**
     * @author JWK
     * @param opts {$target:$('some-selector'), options: {'1':'one','2':'two'}, current: 2, label: 'pick one', 'labelEmpty': 'None Available'}
     * @return void
     */
    Forms.populateSelect = function(opts) {

        // merge opts with defaults
        var defs = {
                $target: null,
                options: {},
                current: null,
                label: 'Select',
                labelEmpty: 'None Available'
            },
            opts = $.extend({}, defs, opts)
        ;

        if (typeof opts.$target !== 'object' || !opts.$target.length) {
            return;
        }

        // if we don't have any options, indicate that and be done
        if (!getObjectCount(opts.options)) {
            opts.$target.html('<option>' + opts.labelEmpty + '</option>');
            return;
        }

        // empty out the select options; rebuild below
        opts.$target.html('');

        // build the options html
        var optionsHtml = '<option value="">' + opts.label || 'Select One' + '</option>';

        $.each(opts.options, function(key, val) {
            var sel = (key == opts.current) ? ' selected="selected"' : '';
            optionsHtml += '<option value="' + key + '"' + sel + '>' + val + '</option>';
        });

        opts.$target.html(optionsHtml);
    };

    /**
     * @author JWK
     * @param afterElementSelector string A CSS-style selector used to identify the element after which the success will be injected
     * @param successMessage string
     * @param timeoutMilliseconds number
     */
    Forms.showInlineSuccess = function(afterElementSelector, successMessage, timeoutMilliseconds) {

        let $successEl = $('<span class="inline-success-message"><i class="fa fa-check-circle"></i> ' + (successMessage || '') + '</span>'),
            $afterEl = $(afterElementSelector);

        if (!$afterEl.length) {
            return;
        }

        if ($afterEl.next('.inline-success-message').length == 0) {
            $successEl.insertAfter($afterEl);
        }

        setTimeout(() => {
            $successEl.fadeOut(250, () => {
                $successEl.remove();
            });
        }, timeoutMilliseconds || 5000);
    };

    var getObjectCount = function(obj) {

        var cnt = 0, key;

        for (key in obj) {
            if (obj.hasOwnProperty(key)) cnt++;
        }

        return cnt;
    };

    return Forms;
};
